import { useEffect, useState } from "react";
import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";

export function useDrawingManager(
  initialValue: google.maps.drawing.DrawingManager | null = null,
) {
  /**
   * Hook to create a Google Maps drawing manager
   * (see https://visgl.github.io/react-google-maps/examples/drawing).
   */
  const map = useMap();
  const drawing = useMapsLibrary("drawing");

  const [drawingManager, setDrawingManager] =
    useState<google.maps.drawing.DrawingManager | null>(initialValue);

  useEffect(() => {
    if (map && drawing) {
      // https://developers.google.com/maps/documentation/javascript/reference/drawing
      const newDrawingManager = new drawing.DrawingManager({
        map,
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [google.maps.drawing.OverlayType.POLYGON],
        },
        polygonOptions: {
          editable: true,
          draggable: true,
        },
      });

      setDrawingManager(newDrawingManager);

      return () => {
        newDrawingManager.setMap(null);
      };
    }
  }, [drawing, map]);

  return drawingManager;
}
